import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingIndicatorService } from '../../../../services/loading-indicator/loading-indicator.service';
import { ConfigService } from '../../../../services/configservice/config.service';
import { EventsService } from '../../../../services/events/events.service';
import { BreadCrumbElement } from '../../../../shared/entities/breadcrumb.element.entity';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { FieldsBasicPlaceDetails } from '../../../../shared/consts/fields-basic-place-details';

@Component({
  selector: 'app-destination-override-add',
  templateUrl: './destination-override-add.component.html',
  styleUrls: ['./destination-override-add.component.css']
})
export class DestinationOverrideAddComponent {
  /* */
  public breadCrumbElements: Array<BreadCrumbElement> = [];

  /* */
  public backgroundImage = '/assets/media/photos/photo21@2x.jpg';
  public containerBackgroundImage = {'background-image': 'url(' + this.backgroundImage + ')'};
  public subContainerBackgroundImage = {};
  public containerClass = {'bg-image': true};
  public subContainerClass = {'bg-white-op-90': true};
  public contentClass: any = {'content': true, 'text-center': true, 'content-top': true};
  public pyClass = {'py-50': true};
  public h1class: any = {'h1': true};
  public h2class: any = {'h4': true};

  public form: FormGroup;

  public options = {
    fields: FieldsBasicPlaceDetails,
  };
  public googleLocationNew = null;
  public googleLocationNewReadable = null;
  public googleLocationOriginal = null;
  public googleLocationOriginalReadable = null;


  constructor(private loadingIndicatorService: LoadingIndicatorService,
              private configService: ConfigService,
              private eventsService: EventsService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private http: HttpClient) {

    /* */
    this.breadCrumbElements = [
      new BreadCrumbElement('tripmakery', 'javascript:void(0)'),
      new BreadCrumbElement('Destination Override', 'javascript:void(0)'),
      new BreadCrumbElement('Add Destination', 'javascript:void(0)')
    ];
  }

  public async handleGooglePlaceIdChangeOriginal(address: Address) {
    this.googleLocationOriginal = address;
    this.googleLocationOriginalReadable = JSON.stringify(this.googleLocationOriginal, null, 2);
  }

  public async handleGooglePlaceIdChangeNew(address: Address) {
    this.googleLocationNew = address;
    this.googleLocationNewReadable = JSON.stringify(this.googleLocationNew, null, 2);
  }

  public async postNewDestinationOverride() {
    if (this.googleLocationOriginal == null ||
      this.googleLocationNew == null) {
      return;
    }

    this.loadingIndicatorService.showLoadingBar();

    this.http.post(environment.urls.service + '/api/v1/authenticated/admin/destination-override/',
      {
        selectedDestination: this.googleLocationOriginal,
        replacedDestination: this.googleLocationNew,
        isActive: true,
        autocompletionName: this.googleLocationOriginal.formatted_address,
      })
      .subscribe((response: any) => {
          this.loadingIndicatorService.hideLoadingBar();

          this.router.navigate(['/destination-override', response._id]);
        },
        error => {
          if (error.error === 'Unauthorized') {
          }
          console.log('Error', error);
          this.loadingIndicatorService.hideLoadingBar();
          this.eventsService.broadcast('requestShowErrorMessage', JSON.stringify(error));

        }
      );
  }

}
